import React, {forwardRef} from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {NewSearchWidgetEntitiesSection} from "./entities/new-search-widget.entities.section";
import {NewSearchWidgetSearchEmptyState} from "./new-search-widget.search-empty-state";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import {NewSearchWidgetPopularAndResultsKeyboardClickComposer} from "../composers/new-search-widget.popular-and-results-keyboard-click.composer";

export const NewSearchWidgetPopularAndResults = NewSearchWidgetPopularAndResultsKeyboardClickComposer(observer(forwardRef(({controller, competitionHighlightedIndex, competitorHighlightedIndex, athleteHighlightedIndex, onMouseEnter}, ref) => {
  const {state} = controller;
  const {
    competitionsListModel,
    competitorsListModel,
    athletesListModel,
    competitionsSearchListModel,
    competitorsSearchListModel,
    athletesSearchListModel,
    shouldRenderSearchEmptyState,
    searchModelsExists,
    isPopularAndResultsHighlighted,
  } = state;

  const containerProps = {
    ref,
    className: classNames(styles.popular_and_results_container, {[styles.tab_section]: isPopularAndResultsHighlighted}),
    onMouseEnter: () => controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {index: NEW_SEARCH_WIDGET.TAB_SECTION.popularAndResults})
  }

  const competitionsProps = {
    controller,
    onMouseEnter,
    highlightedItemIndex: competitionHighlightedIndex,
    listModel: searchModelsExists ? competitionsSearchListModel : competitionsListModel
  }

  const competitorsProps = {
    controller,
    onMouseEnter,
    highlightedItemIndex: competitorHighlightedIndex,
    listModel: searchModelsExists ? competitorsSearchListModel : competitorsListModel
  }

  const athletesProps = {
    controller,
    onMouseEnter,
    highlightedItemIndex: athleteHighlightedIndex,
    listModel: searchModelsExists ? athletesSearchListModel : athletesListModel
  }

  return shouldRenderSearchEmptyState ? <NewSearchWidgetSearchEmptyState controller={controller}/> :
    <div {...containerProps}>
      <NewSearchWidgetEntitiesSection {...competitionsProps}/>
      <NewSearchWidgetEntitiesSection {...competitorsProps}/>
      <NewSearchWidgetEntitiesSection {...athletesProps}/>
    </div>
})));
